/** Pixel width of the open corner panel. The app shell reads this and narrows beside it. */
export const GAIL_ASSISTANT_PANEL_WIDTH_VAR = "--gail-assistant-panel-width";
/**
 * Page layout transition duration. The sheet zeroes it for the frame its width changes,
 * so the page settles in one layout pass instead of reflowing on every animation frame.
 */
export const GAIL_ASSISTANT_PANEL_EASE_VAR = "--gail-assistant-panel-ease";
export const GAIL_ASSISTANT_PANEL_TIMING = "cubic-bezier(0.22, 1, 0.36, 1)";
/** The sheet slides on `transform` only; closing is a little quicker than opening. */
export const GAIL_ASSISTANT_PANEL_OPEN_MS = 300;
export const GAIL_ASSISTANT_PANEL_CLOSE_MS = 240;
/** A brief, movement-free handoff between the welcome and conversation. */
export const GAIL_ASSISTANT_CONTENT_TRANSITION = {
  duration: 0.15,
  ease: [0.22, 1, 0.36, 1] as const,
};

// Routes where a floating GailGPT button duplicates a chat that is already on screen.
const HIDDEN_ROUTES = [/^\/workflows\/[^/]+\/builder/, /^\/skills/, /^\/gailgpt(\/|$)/];

/**
 * The corner button replaces Logan on ordinary pages for members with GailGPT chat access.
 * The legacy dock, the full-page chat, and the workflow builder already have their own chat.
 */
export function shouldShowGailGptLauncher(
  pathname: string,
  canUseGailGptChat: boolean,
  isDockAvailable: boolean
): boolean {
  if (!canUseGailGptChat || isDockAvailable) return false;
  return !HIDDEN_ROUTES.some((route) => route.test(pathname));
}
